import { render, staticRenderFns } from "./StatusHistoryTimeline.vue?vue&type=template&id=484cb9f2&scoped=true"
import script from "./StatusHistoryTimeline.vue?vue&type=script&lang=ts"
export * from "./StatusHistoryTimeline.vue?vue&type=script&lang=ts"
import style0 from "./StatusHistoryTimeline.vue?vue&type=style&index=0&id=484cb9f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484cb9f2",
  null
  
)

export default component.exports